<template>
  <el-collapse v-model="activeCollapses" class="el-card-collapse">
    <el-collapse-item title="基本信息" name="Basic">
      <detail-base ref="baseRef" v-model="storeInfo" :rules="rules" :can-edit="canEdit" :disabled="!isCreate" />
    </el-collapse-item>
    <el-collapse-item title="账户信息" name="Bank">
      <detail-account ref="accountRef" v-model="storeInfo" :rules="rules" :can-edit="canEdit" />
    </el-collapse-item>
    <el-collapse-item title="证件信息" name="Photo">
      <detail-photo ref="photoRef" v-model="images" :detail="storeInfo.detail" :disabled="!canEdit" />
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import util from '@/utils'
import { rules } from './validate'
import { uploadFile } from '@/api/oss'
import { getStoreDetail, submitStoreInfo } from '@/api/store'
import { detailBase, detailAccount, detailPhoto } from '@/components/ShopDetail'

export default {
  name: 'StoreReview',
  components: { detailBase, detailAccount, detailPhoto },
  emits: ['create'],
  props: {
    canEdit: Boolean,
    isCreate: Boolean,
    storeId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      activeCollapses: ['Basic', 'Bank', 'Photo'],
      storeInfo: this.initData(),
      images: [],
      showRegion: true,
      regionOptions: this.$store.getters.regionMap,
      rules
    }
  },
  watch: {
    storeId: {
      deep: true,
      immediate: true,
      handler(value) {
        this.initData()
        if (value) this.fetchData()
      }
    }
  },
  methods: {
    fetchData() {
      getStoreDetail(this.storeId).then(response => {
        const storeInfo = Object.assign({}, response)
        if (storeInfo.detail) {
          storeInfo.detail.licenseDateType = storeInfo.detail.licenseExpire ? 1 : 2
          storeInfo.detail.licenseDate = storeInfo.detail.licenseExpire ? [storeInfo.detail.licenseStart, storeInfo.detail.licenseExpire] : []
          storeInfo.detail.cardDateType = storeInfo.detail.legalCardExpire ? 1 : 2
          storeInfo.detail.cardDate = storeInfo.detail.legalCardExpire ? [storeInfo.detail.legalCardStart, storeInfo.detail.legalCardExpire] : []
          storeInfo.openHours = storeInfo.openTime ? storeInfo.openTime.split(' - ') : []

          this.showRegion = false
          storeInfo.regionInfo = storeInfo.regionCode ? storeInfo.regionCode.split(/,\s*/) : []
          util.delay(100).then(() => { this.showRegion = true })
        } else {
          storeInfo.detail = Object.assign({}, this.initDetail())
        }
        this.storeInfo = Object.assign({}, storeInfo)
      })
    },
    initData() {
      this.storeInfo = Object.assign({}, {
        address: '',
        inviteCode: '',
        shopName: '',
        shortName: '',
        discount: 20,
        openHours: [],
        regionInfo: [],
        mobile: '',
        password: '',
        merchantId: '',
        phone: '',
        feature: '',
        sortBy: '',
        detail: this.initDetail()
      })
    },
    initDetail() {
      return {
        workingGroup: 12,
        merchantType: 2,
        accountType: 1,
        licenceNo: '',
        licenseDateType: 1,
        licenseDate: '',
        licenseStart: '',
        legalName: '',
        legalIdCard: '',
        cardDateType: 1,
        cardDate: '',
        legalCardStart: '',
        qualification: ''
      }
    },
    regionChange(regionValue) {
      this.storeInfo.regionCode = (regionValue && regionValue.length) ? regionValue.join(',') : ''
      this.storeInfo.regionName = (regionValue && regionValue.length) ? this.$refs.regionCascader.getCheckedNodes()[0].pathLabels.join('') : ''
    },
    uploadImages() {
      return new Promise((resolve, reject) => {
        if (this.images && this.images.length) {
          const uploadFiles = this.images.filter(item => item.url && item.file)
          const uploadPromises = uploadFiles.map(image => uploadFile(image.file))
          Promise.all(uploadPromises).then(response => {
            const images = [...this.images]
            images.forEach(item => {
              const index = uploadFiles.findIndex(upload => upload.field === item.field)
              if (index >= 0) Object.assign(item, { url: response[index], file: undefined })
            })
            this.images = [...images]
            resolve()
          }).catch(() => reject('图片上传失败'))
        } else {
          resolve()
        }
      })
    },
    async onSave() {
      try {
        await this.$refs.baseRef.validate()
        await this.$refs.accountRef.validate()
        await this.$refs.photoRef.validate()
        await this.uploadImages()

        this.images.forEach(image => {
          if (image.field.startsWith('premisePhoto')) {
            const photo = this.storeInfo.detail.premisePhoto ? this.storeInfo.detail.premisePhoto.split(',') : []
            photo[image.field === 'premisePhoto1' ? 0 : 1] = image.url
            this.storeInfo.detail.premisePhoto = [...photo].join(',')
          } else if (image.field.startsWith('legalCardPhoto')) {
            const photo = this.storeInfo.detail.legalCardPhoto ? this.storeInfo.detail.legalCardPhoto.split(',') : []
            photo[image.field === 'legalCardPhoto1' ? 0 : 1] = image.url
            this.storeInfo.detail.legalCardPhoto = [...photo].join(',')
          } else {
            this.storeInfo.detail[image.field] = image.url
            if (image.field === 'doorPhoto') this.storeInfo.avatar = image.url
          }
        })

        if (this.storeInfo.detail.licenseDateType === 1 && this.storeInfo.detail.licenseDate && this.storeInfo.detail.licenseDate.length) {
          this.storeInfo.detail.licenseStart = this.storeInfo.detail.licenseDate[0]
          this.storeInfo.detail.licenseExpire = this.storeInfo.detail.licenseDate[1]
        } else {
          this.storeInfo.detail.licenseExpire = ''
        }
        if (this.storeInfo.detail.cardDateType === 1 && this.storeInfo.detail.cardDate && this.storeInfo.detail.cardDate.length) {
          this.storeInfo.detail.legalCardStart = this.storeInfo.detail.cardDate[0]
          this.storeInfo.detail.legalCardExpire = this.storeInfo.detail.cardDate[1]
        } else {
          this.storeInfo.detail.legalCardExpire = ''
        }
        this.storeInfo.detail.servicePhone = this.storeInfo.phone
        this.storeInfo.openTime = this.storeInfo.openHours.join(' - ')

        await submitStoreInfo(this.storeInfo)
        return true
      } catch (error) {
        console.error(error)
        // reject('商家数据提交保存失败')
        return Promise.reject('商家数据提交保存失败')
      }
    },
    onCreateNew() {
      if (this.storeId) {
        this.$emit('create')
      } else {
        this.$refs.detailForm.resetFields()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-radio-group {
  display: inline-flex;
  align-items: center;
  .el-radio {
    flex: 1;
  }
}
.el-form-item {
  .max-width {
    max-width: 200px;
  }
  .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    max-width: 100%;
    width: 100%;
  }
}
</style>
